import { Dimensions, Modal, Platform, StyleSheet, View } from 'react-native'
import NewApp from '@app/App'
import useWindowDimensionsThrottled from '@app/hooks/useWindowDimensionsThrottled';
import { getScreenType } from '@app/sharedComponents/stack/utils';
import AppBarWeb from '@app/sharedComponents/AppBarWeb';
import { getParameters, isFromTDLPlatform, isIframeCheck, parseParameters, useDarkMode } from '@app/utils';
import { PLATFORM_NAME } from '@app/types/regix';
import { useCallback, useEffect, useMemo, useState } from 'react';
import createDynamicTheme from '@app/theme';
import { ThemeProvider } from '@shopify/restyle';
import { firebaseInit } from './utils';
import { fetchAndActivate, getAll, getValue } from 'firebase/remote-config';
import { updateFirebaseParams } from '@app/store/slices/firebaseParamsSlice';
import { useAppDispatch } from '@app/store/hooks';
import LogoutConfirmationModal from '@app/sharedComponents/LogoutConfirmationModal';
import useIsOnScreenKeyboardOpen from '@app/hooks/useKeyboardIOS';
import PageNotFound from '@app/screens/PageNotFound';
import * as Sentry from '@sentry/react-native';
import { loadFont } from '@app/utils/fontloader';
import { initGoogleAuth } from '@app/utils/googleClient';
import { ContactNumbersProvider } from '@app/contexts/ContactNumbersContext';

Sentry.init({
  dsn: 'https://5f01f31b9f814dcabada5a2dd5b922cb@o4504883868008448.ingest.sentry.io/4504883869908992',
});

const SCREEN_HEIGHT = Dimensions.get("window").height;

const AppWebNew = () => {

  // states 
  const [showSupportPhoneNumber, setShowSupportPhoneNumber] = useState(true);
  const [logoutModalVisible, setLogoutModalVisible] = useState(false);


  // hooks 
  const dispatch = useAppDispatch()
  const { isOpen: isKeyboardVisible, keyboardHeight } = useIsOnScreenKeyboardOpen();
  const { width, height } = useWindowDimensionsThrottled(50);
  const isDarkMode = useDarkMode();


  const url = Platform.OS === 'web' ? window.location.href : '';
  const params = Platform.OS === 'web' ? getParameters(url) : {};
  const sdkParams = Platform.OS === 'web' ? parseParameters(url) : {};

  const isPartnerPlatform = url.toLowerCase().includes('partnerplatform');
  const isMarketing = url.toLowerCase().includes('marketing');


  // URL Parmeters parsed from url
  const isIframe = params?.isIframe;
  const showDefaultVoltLogo = params?.showVoltLogo;
  const platform = params?.platform;
  const showVoltDefaultHeader = params?.showVoltDefaultHeader;


  const isFromInvestWellSDK = isPartnerPlatform && platform === PLATFORM_NAME.SDK_INVESTWELL;
  const isFreo = platform === PLATFORM_NAME.FREO;

  // SDK Specific parameters from url
  const customLogoUrl = sdkParams?.customLogoUrl;
  const isMobileView = getScreenType(width) === 'small' || getScreenType(width) === 'extra_small'

  const showHeader = platform === PLATFORM_NAME.JUPITER || platform === PLATFORM_NAME.SDK_INVESTWELL || isMarketing || isIframeCheck() || showVoltDefaultHeader === 'false' ? false : true


  const APP_WIDTH = isMobileView ? width : 508;
  const APP_HEIGHT = isMobileView ? height : showHeader ? height - 114 : height;



  const toggleModal = useCallback(() => {
    setLogoutModalVisible((prev) => !prev)
  }, [])


  useEffect(()=> {
     if (Platform.OS === 'web') {
      initGoogleAuth()
    }
  },[])

  
  useEffect(() => {

    
    // @ts-ignore
    if (Platform.OS === 'web') {
      const remoteConfig = firebaseInit();
      async function fetchRemoteConfig() {
        try {
          await fetchAndActivate(remoteConfig);
          const allConfigs = getAll(remoteConfig);
          const outputObject = {};
          for (const [key, value] of Object.entries(allConfigs)) {
            //@ts-ignore
            outputObject[key] = value._value;
          }
          dispatch(updateFirebaseParams(outputObject));

        } catch (error) {
          console.error('Error fetching and activating remote config:', error);
        }
      }
      fetchRemoteConfig();
    }
    if (isFromTDLPlatform()) {
      loadFont()
    }
  }, []);



  let primaryColor = null;
  let secondaryColor = null;

  if (Platform.OS === 'web') {
    primaryColor = getParameters(window?.location?.href).primaryColor;
    secondaryColor = getParameters(window?.location?.href).secondaryColor;
  }

  const theme = useMemo(
    () => createDynamicTheme('core', isDarkMode ? 'dark' : 'light', primaryColor , secondaryColor),
    [],
  );

  if (isMobileView) {
    return (
      <ThemeProvider theme={theme}>
      <View style={{
        height: Platform.OS === "web" ? "100dvh" : "100%",
        minHeight: isKeyboardVisible ? '90vh' : 'auto'
      }}>
        <ContactNumbersProvider>
          <NewApp extraProps={{
            routingSupport: {},
            setRoutingSupport: () => { },
            setIsUserLoggedIn: () => { },
            startWithOldArch: false
          }} />
        </ContactNumbersProvider>
      </View>
      </ThemeProvider>
    )
  }



  return (
    <ThemeProvider theme={theme}>
      <View style={{ backgroundColor: "#F2F2F2", height: '100vh', alignItems: 'center' }}>
        <ContactNumbersProvider>
          {!isMobileView && showHeader ? (
            <AppBarWeb toggleModal={toggleModal} showLogout={true} platform={platform} showSupportPhoneNumber={showSupportPhoneNumber} isFromInvestWellSDK={isFromInvestWellSDK} showDefaultVoltLogo={showDefaultVoltLogo} customLogoUrl={customLogoUrl} />
          ) : null}
          <View style={{
            height: APP_HEIGHT, width: APP_WIDTH, minHeight: isKeyboardVisible ? '90vh' : 'auto',
          }}>
            {isFreo ? (
              <PageNotFound />
            ) : (
              <NewApp extraProps={{
                routingSupport: {},
                setRoutingSupport: () => { },
                setIsUserLoggedIn: () => { },
                startWithOldArch: false
              }} />
            )}
          </View>
        </ContactNumbersProvider>
      </View>
      <LogoutConfirmationModal modalVisible={logoutModalVisible} toggleModal={toggleModal} />
    </ThemeProvider>
  )
}

export default AppWebNew
